import { Callout } from "@blueprintjs/core";
import * as React from "react";
import Loader from "~/components/Loader";
import ProductImageModerationFormContainer from "~/containers/ProductImageModerationFormContainer";
import client from "~/graphql/client";
import {
  IAliExpressPullingImage,
  IOption,
  OPTION_PENDING_MODERATION_QUERY,
  OptionPendingModeration
} from "~/graphql/queries/aliexpress/optionPendingModeration";
interface IState {
  inFlightRequests: number;
  productImageQueue: IOption[];
}

export default class ProductImageContainer extends React.Component<{}, IState> {
  public state: IState = {
    inFlightRequests: 0,
    productImageQueue: []
  };

  public render() {
    const { inFlightRequests, productImageQueue } = this.state;

    if (inFlightRequests > 0 && productImageQueue.length === 0) {
      return <Loader />;
    }

    if (productImageQueue.length === 0) {
      return (
        <Callout intent="danger" title="No more images">
          No more images left to moderate.
        </Callout>
      );
    }

    const {
      id,
      product,
      aliexpressPullingImages,
      entities
    } = productImageQueue[0];

    if (!aliexpressPullingImages) {
      throw new Error("Option has no pulling images");
    }

    const colorEntity =
      entities && entities.length
        ? entities.find(entity => !!entity.entity.match(/(color|kleur)/i))
        : null;

    const mainImage = colorEntity
      ? aliexpressPullingImages.find(
          image => image.optionValue === colorEntity.value
        )
      : aliexpressPullingImages.find(image => !image.parentImageId);

    return (
      <ProductImageModerationFormContainer
        product={product}
        images={aliexpressPullingImages!}
        mainImageId={mainImage ? mainImage.id : null}
        optionId={id}
        color={colorEntity ? colorEntity.value : null}
        onFinish={this.handleFinish}
      />
    );
  }

  public handleFinish = () => {
    window.scrollTo(0, 0);
    this.setState(state => ({
      productImageQueue: state.productImageQueue.slice(1)
    }));
    this.fetchProductImages();
  };

  public async componentDidMount() {
    await this.fetchProductImages();
    await this.fetchProductImages();
    await this.fetchProductImages();
    await this.fetchProductImages();
    await this.fetchProductImages();
  }

  private async fetchProductImages() {
    try {
      this.setState(state => ({
        inFlightRequests: state.inFlightRequests + 1
      }));

      const {
        data: { option }
      } = await client.query<OptionPendingModeration>({
        fetchPolicy: "network-only",
        query: OPTION_PENDING_MODERATION_QUERY,
        variables: {}
      });

      if (!option || option.aliexpressPullingImages === null) {
        throw new Error("Option has no images");
      }

      // Skip options without images
      if (option.aliexpressPullingImages.length === 0) {
        this.fetchProductImages();
        this.setState(state => ({
          inFlightRequests: state.inFlightRequests - 1
        }));

        return;
      }

      await this.preloadImages(option.aliexpressPullingImages);

      this.setState(state => ({
        productImageQueue: [...state.productImageQueue, option]
      }));
    } catch (error) {
      // tslint:disable-next-line:no-console
      console.error(error);
    } finally {
      this.setState(state => ({
        inFlightRequests: state.inFlightRequests - 1
      }));
    }
  }

  private async preloadImages(
    images: IAliExpressPullingImage[]
  ): Promise<void> {
    await Promise.all(images.map(image => this.preloadImage(image.imageUrl)));
  }

  private async preloadImage(url: string): Promise<void> {
    const image = document.createElement("img");
    image.src = url.replace("http:", "https:");

    return new Promise<void>(resolve => {
      image.onload = () => resolve();
      image.onerror = () => resolve();
    });
  }
}



// WEBPACK FOOTER //
// ./src/containers/ProductImageContainer.tsx